import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { AbuStory } from './components/AbuStory';
import { ProblemReveal } from './components/ProblemReveal';
import { ProductReveal } from './components/ProductReveal';
import { TransformationGrid } from './components/TransformationGrid';
import { BonusGrid } from './components/BonusGrid';
import { Testimonials } from './components/Testimonials';
import { RealTestimonials } from './components/RealTestimonials';
import { ValueStack } from './components/ValueStack';
import { CountdownCTA } from './components/CountdownCTA';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SectionDivider } from './components/SectionDivider';
export function App() {
  return <div className="min-h-screen bg-brand-bg font-sans text-brand-text selection:bg-brand-rose/30" data-id="element-0">
      <Hero data-id="element-1" />

      <SectionDivider quote="No es que el universo no te escuche. Es que nunca te enseñaron cómo hablarle." data-id="element-2" />

      <PainPoints data-id="element-3" />

      <AbuStory data-id="element-4" />

      <SectionDivider quote="La abundancia no se persigue. Se recibe — cuando aprendes a merecerla." data-id="element-5" />

      <ProblemReveal data-id="element-6" />

      <ProductReveal data-id="element-7" />

      <TransformationGrid data-id="element-8" />

      <SectionDivider quote="Un café te dura un día. Este libro puede durar toda una vida." data-id="element-9" />

      <BonusGrid data-id="element-10" />

      <Testimonials data-id="element-11" />

      <RealTestimonials data-id="element-12" />

      <SectionDivider quote="Llevas años dando lo mejor de ti. Hoy es hora de recibir." data-id="element-13" />

      <ValueStack data-id="element-14" />

      <CountdownCTA data-id="element-15" />

      <Guarantee data-id="element-16" />

      <FAQ data-id="element-17" />

      <SectionDivider quote="La paz que deseas no es un lujo. Es tu derecho." data-id="element-18" />

      <FinalCTA data-id="element-19" />

      <Footer data-id="element-20" />
    </div>;
}